import { useTranslation } from 'react-i18next';

import { loaders, actions, User } from 'entities';

import { Column, LabeledInput, LabeledSelect } from 'components/Blocks';

import UserPicture from './Picture';

import { useAuth } from 'providers/Auth';

import { LanguagesIcon, MailIcon, UserBookIcon, UsersIcon } from 'components/Icons';

function UserProfile() {
  const {
    user: { data },
    updateUserMainData,
  } = useAuth();

  const { t, i18n } = useTranslation();

  loaders.users.find.use({
    params: { id: data.id },

    onDataChange: updateUserMainData,
  });

  const changeLanguage = actions.users.changeOwnLanguage.use({
    onSuccess: ({ language }) => {
      updateUserMainData({ language });

      i18n.changeLanguage(language);
    },
  });

  return (
    <Column>
      <h5>{t('my-profile')}</h5>

      <Column gap="6" className="mx-auto w-[min(80%,800px)]">
        <UserPicture />

        <LabeledInput
          id="name"
          value={data.name}
          label={t('name')}
          disabled
          labelIcon={UserBookIcon}
        />

        <LabeledInput
          id="email"
          value={data.email}
          label={t('email')}
          disabled
          labelIcon={MailIcon}
        />

        <LabeledInput
          id="team"
          value={data.team.name}
          label={t('team')}
          disabled
          labelIcon={UsersIcon}
        />

        <LabeledSelect
          id="language"
          label={t('language') as string}
          loading={changeLanguage.loading}
          value={data.language}
          labelIcon={LanguagesIcon}
          onChangeDirect={(language) =>
            changeLanguage.execute({ language: language as User['language'] })
          }
          options={[
            {
              value: 'en',
              label: t('english'),
            },
            {
              value: 'es',
              label: t('spanish'),
            },
            {
              value: 'pt',
              label: t('portuguese'),
            },
          ]}
        />
      </Column>
    </Column>
  );
}

export default UserProfile;
